import { render } from "./FullScreenDisplay.vue?vue&type=template&id=53038aa2&scoped=true&ts=true&style=width%3A%20100%25%3B%20height%3A%20100%25"
import script from "./FullScreenDisplay.vue?vue&type=script&lang=ts"
export * from "./FullScreenDisplay.vue?vue&type=script&lang=ts"

import "./FullScreenDisplay.vue?vue&type=style&index=0&id=53038aa2&scoped=true&lang=css"
import "./FullScreenDisplay.vue?vue&type=style&index=1&id=53038aa2&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53038aa2"]])

export default __exports__